import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './render-content.module.scss';
import { useKnowledgeHub } from '../hooks/use-knowledge-hub.hooks';
import { NotFound } from 'src/components/common';
import { CategoryBoxComponent } from 'src/components/common/categories/category-box';
import { CATEGORY_TYPES } from 'shared/constants';
import { SectionComponent } from 'src/components/common/section/section.component';
import { Loader } from 'src/components/core';
import { RenderBinder } from './render-binder';
import { notification } from 'antd';
import { getLang } from 'shared/store/selectors/lang.selector';

export function RenderContent() {
  const {
    organizationId,
    workspaceId,
    workspacesList,
    onSelectWorkspace,
    knowledgeCategories,
    onSelectCategory,
    onSelectBinder,
    loading,
    error,
  } = useKnowledgeHub();
  const lang = useSelector(getLang('KNOWLEDGE_HUB'));

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Something went wrong',
        placement: 'bottomRight',
      });
    }
  }, [error]);

  if (!organizationId) return null;

  const renderEmptyState = () => {
    if (loading || error || workspaceId || workspacesList.length > 0) return null;

    return <NotFound text={lang.NO_SHARED_CONTENT} />;
  };

  const renderWorkspaceList = () => {
    if (loading || error || !workspacesList.length || workspaceId || workspacesList.length === 1)
      return null;

    return (
      <div className={styles.workspaceContainer}>
        {workspacesList
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(workspace => (
            <button
              type="button"
              key={workspace.id}
              id={workspace.id}
              className={styles.box}
              onClick={onSelectWorkspace}>
              <CategoryBoxComponent title={workspace.name} type={CATEGORY_TYPES.CATEGORY} />
            </button>
          ))}
      </div>
    );
  };

  const renderCategories = () => {
    if (loading || error || !workspaceId || !knowledgeCategories) return null;

    return knowledgeCategories.map(section => (
      <SectionComponent key={section.id} title={section.title}>
        {section.subcategories.map(cat => {
          const isBinder = cat?.type === CATEGORY_TYPES.KNOWLEDGE;
          const onClick = isBinder ? onSelectBinder : onSelectCategory;

          return (
            <button
              type="button"
              key={cat?.id}
              id={cat?.id}
              className={styles.box}
              onClick={onClick}>
              <CategoryBoxComponent {...cat} />
            </button>
          );
        })}
      </SectionComponent>
    ));
  };

  const renderNotFound = () => {
    // Show NotFound when there's an error or when workspace is selected but no categories
    if (!loading && organizationId && workspaceId && (error || !knowledgeCategories)) {
      return <NotFound />;
    }
  };
  const renderLoading = () => {
    if (!loading) return;

    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    );
  };

  return (
    <div className={styles.root}>
      {renderEmptyState()}
      {renderWorkspaceList()}
      {renderCategories()}
      {renderLoading()}
      {renderNotFound()}
      <RenderBinder />
    </div>
  );
}
